import { render, staticRenderFns } from "./WEBSITE.vue?vue&type=template&id=24523378&scoped=true&"
import script from "./WEBSITE.vue?vue&type=script&lang=js&"
export * from "./WEBSITE.vue?vue&type=script&lang=js&"
import style0 from "./WEBSITE.vue?vue&type=style&index=0&id=24523378&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24523378",
  null
  
)

export default component.exports